<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-analytics"
    :showFooter="true"
    :showSubmit="false"
    @closed="onClosed">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="form" :labelColumnSize="3" v-show="!loading">
      <Scroller :maxHeight="500">
        <StaticDataTable class="static-table-list station-table mt-2">
          <template v-slot:header>
            <tr>
              <th>Size (HxW)</th>
              <th>Barcode</th>
              <th>Stock On Hand</th>
              <th>Bin</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="glassLevel in glassLevelList" :key="glassLevel.id" :ref="`glassLevelRow-${glassLevel.id}`" @click.prevent="selectedGlassLevelId = glassLevel.id">
              <td class="font-weight-bold">
                {{glassLevel.height}} x {{glassLevel.width}}
                <LabelBadge labelClass="label-stock-general" v-if="glassLevel.isOffcut">Offcut</LabelBadge>
              </td>
              <td>
                <span v-if="glassLevel.isOffcut">{{glassLevel.barcode}}</span>
                <span v-if="!glassLevel.isOffcut">-</span>
              </td>
              <td>{{glassLevel.qtyOnHand}}</td>
              <td>
                <span v-if="glassLevel.isOffcut">{{formatHyphenEmptyValue(glassLevel.inventoryBin ? glassLevel.inventoryBin.code : '')}}</span>
                <span v-if="!glassLevel.isOffcut">-</span>
              </td>
            </tr>
          </template>
          <template v-slot:empty v-if="glassLevelList.length == 0">No glass levels found</template>
        </StaticDataTable>
      </Scroller>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'StockLevelDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    stockId: Number
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      stockData: { },
      glassLevelList: [],
      form: {}
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    title() {
      if(this.stockData.name)
        return `Stock Levels for ${this.stockData.name}`
      return 'Stock Levels'
    }    
  },
  methods: {
    show() {
      this.form = {}

      this.stockData = { }
      this.glassLevelList = []

      // Download the stock / glass data
      this.requestStockData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },

    requestStockData() {
      this.loadinga = true
      this.loadingError = ''

      this.$apiService.inventoryService.getStock(this.stockId)
      .then(response => {
        this.stockData = response.data

        // Build the list of glass levels
        this.glassLevelList = []
        if(this.stockData.glassSizeList) {
          this.stockData.glassSizeList.forEach(glassSize => {
            if(glassSize.glassLevels) {
              glassSize.glassLevels.forEach(glassLevel => {
                var levelOutput = _.clone(glassLevel)

                this.glassLevelList.push(levelOutput)
              })
            }
          })
        }
      })
      .catch(err => {
        this.loadingError = 'Error loading data'
      })
      .finally(() => {
        this.loading = false
      })
    }

  }
}
</script>